import { useSEO } from "@/lib/useSEO";

const Wrap = ({ title, children }) => (
  <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
    <h1 className="font-heading text-4xl sm:text-5xl font-semibold text-brand-ink mb-8">{title}</h1>
    <div className="prose-article">{children}</div>
  </div>
);

export function Privacidad() {
  useSEO({ title: "Política de privacidad | Ruta Inteligente", description: "Política de privacidad de Ruta Inteligente." });
  return (
    <Wrap title="Política de privacidad">
      <p>En <strong>Ruta Inteligente</strong> nos tomamos en serio la privacidad de nuestros usuarios. Esta política explica qué datos recogemos, con qué finalidad y cuáles son tus derechos.</p>
      <h2>Responsable del tratamiento</h2>
      <p>El responsable de los datos personales recogidos en este sitio web es Ruta Inteligente. Puedes contactarnos en hola@rutainteligente.com.</p>
      <h2>Datos que recogemos</h2>
      <ul>
        <li>Dirección de correo electrónico cuando te suscribes a la newsletter.</li>
        <li>Nombre, email y mensaje cuando usas el formulario de contacto.</li>
        <li>Datos de navegación anónimos a través de cookies analíticas.</li>
      </ul>
      <h2>Finalidad</h2>
      <p>Usamos tus datos para enviarte contenidos y novedades, responder a tus consultas y mejorar la experiencia del sitio. No vendemos ni cedemos tus datos a terceros salvo obligación legal.</p>
      <h2>Publicidad y terceros</h2>
      <p>Este sitio utiliza Google AdSense para mostrar anuncios. Google y sus socios pueden usar cookies para personalizar la publicidad según tu actividad. Puedes gestionar tus preferencias en la configuración de anuncios de Google.</p>
      <h2>Tus derechos</h2>
      <p>Puedes solicitar el acceso, rectificación o supresión de tus datos escribiéndonos a hola@rutainteligente.com.</p>
    </Wrap>
  );
}

export function Cookies() {
  useSEO({ title: "Política de cookies | Ruta Inteligente", description: "Política de cookies de Ruta Inteligente." });
  return (
    <Wrap title="Política de cookies">
      <p>Esta web utiliza cookies propias y de terceros para mejorar tu experiencia, analizar el tráfico y mostrar publicidad relevante.</p>
      <h2>¿Qué son las cookies?</h2>
      <p>Son pequeños archivos que se almacenan en tu navegador. Nos ayudan a recordar tus preferencias y a entender cómo usas el sitio.</p>
      <h2>Tipos de cookies que usamos</h2>
      <ul>
        <li><strong>Técnicas:</strong> necesarias para el funcionamiento del sitio.</li>
        <li><strong>Analíticas:</strong> nos permiten medir y mejorar el contenido (Google Analytics).</li>
        <li><strong>Publicitarias:</strong> utilizadas por Google AdSense para mostrar anuncios personalizados.</li>
      </ul>
      <h2>Gestión de cookies</h2>
      <p>Puedes configurar o desactivar las cookies desde la configuración de tu navegador. Ten en cuenta que algunas funciones podrían dejar de estar disponibles.</p>
    </Wrap>
  );
}

export function AvisoLegal() {
  useSEO({ title: "Aviso legal | Ruta Inteligente", description: "Aviso legal de Ruta Inteligente." });
  return (
    <Wrap title="Aviso legal">
      <p>El presente aviso legal regula el uso del sitio web <strong>rutainteligente.com</strong>.</p>
      <h2>Titularidad</h2>
      <p>Este sitio es titularidad de Ruta Inteligente. El acceso y uso del sitio atribuye la condición de usuario y supone la aceptación de las presentes condiciones.</p>
      <h2>Propiedad intelectual</h2>
      <p>Todos los contenidos (textos, imágenes, diseño y código) están protegidos por derechos de propiedad intelectual. Queda prohibida su reproducción total o parcial sin autorización.</p>
      <h2>Responsabilidad</h2>
      <p>La información publicada tiene carácter orientativo. Ruta Inteligente no se hace responsable de decisiones tomadas en base a los contenidos. Los precios y disponibilidad pueden variar.</p>
      <h2>Enlaces de afiliados</h2>
      <p>Algunos enlaces pueden ser de afiliación: si reservas a través de ellos, podríamos recibir una comisión sin coste adicional para ti.</p>
    </Wrap>
  );
}

export function SobreNosotros() {
  useSEO({ title: "Sobre nosotros | Ruta Inteligente", description: "Conoce el proyecto Ruta Inteligente, tu web de viajes low cost." });
  return (
    <Wrap title="Sobre nosotros">
      <p><strong>Ruta Inteligente</strong> nace con una idea simple: viajar no tiene por qué ser caro. Creamos guías honestas y prácticas para ayudarte a ver el mundo gastando mucho menos.</p>
      <h2>Qué hacemos</h2>
      <p>Investigamos destinos económicos, comparamos herramientas de vuelos, probamos formas de alojamiento barato y compartimos trucos reales que funcionan. Sin humo, sin relleno.</p>
      <h2>Nuestra misión</h2>
      <p>Que cualquier persona, sin importar su presupuesto, pueda organizar viajes increíbles. Creemos en el viaje inteligente: el que aprovecha cada euro al máximo.</p>
      <h2>Cómo nos financiamos</h2>
      <p>Mantenemos el contenido gratuito gracias a la publicidad y a algunos enlaces de afiliación. Esto nos permite seguir creando guías sin coste para ti.</p>
    </Wrap>
  );
}
